import ApiClient from './ApiClient';

class ContactReasonsAPI extends ApiClient {
  constructor() {
    super('contact_reasons', { accountScoped: true });
  }
}

export default new ContactReasonsAPI();
